var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGitHubLookup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2771 1294",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 2770.53,
    height: 1292.87,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.164,284.145c24.386,-84.501 109.222,-149.086 207.803,-149.086c98.58,0 183.416,64.585 207.802,149.086c85.373,-21.131 183.723,20.046 233.014,105.419c49.29,85.373 35.775,191.136 -25.211,254.505c60.986,63.37 74.501,169.133 25.211,254.506c-49.291,85.373 -147.641,126.55 -233.014,105.419c-24.386,84.501 -109.222,149.086 -207.802,149.086c-98.581,-0 -183.417,-64.585 -207.803,-149.086c-85.373,21.131 -183.723,-20.046 -233.013,-105.419c-49.29,-85.373 -35.776,-191.136 25.21,-254.506c-60.986,-63.369 -74.5,-169.132 -25.21,-254.505c49.29,-85.373 147.64,-126.55 233.013,-105.419Z",
    style: {
      fill: "#5ba4ff",
      stroke: "#1c3553",
      strokeWidth: "71.25px",
      strokeDasharray: "434.63,114,0,0"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: "1268.64px",
    y: "622.643px",
    style: {
      fontFamily: "'Arial-BoldMT', 'Arial', sans-serif",
      fontWeight: 700,
      fontSize: "416.667px",
      fill: "#1c3553"
    }
  }, "GitHub"), /*#__PURE__*/React.createElement("text", {
    x: "1284.3px",
    y: "939.667px",
    style: {
      fontFamily: "'ArialMT', 'Arial', sans-serif",
      fontSize: "333.333px",
      fill: "#1c3553"
    }
  }, "Lookup"));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitHubLookup);
export default __webpack_public_path__ + "static/media/GitHubLookup.99764c2d8584c6110162197ae099321b.svg";
export { ForwardRef as ReactComponent };